/**
 * Created by Fedor on 01.10.2026
 */

const FeedFruitMine = {
    prize: function (level, unit) {
        return [{
            amount: 5,
            probabilities: [0.166, 0.166, 1],
            units: [
                { code: unit.code, stage: 1 },
                { code: "coins", stage: 0 },
                { code: unit.code, stage: 0 }
            ]
        }];
    }
};
